<fieldset [formGroup]="group" class="in-two-columns">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'LIQUEUR_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.LIQUEUR_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="types | toSelectOption: 'PRODUCTS.LIQUEUR_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- fruitOrHerbal -->

  <mat-form-field>
    <app-easy-select
      formControlName="fruitOrHerbal"
      [label]="TITLE + 'LIQUEUR_FRUIT_HERBAL' | translate"
      [translatePrefixForSelected]="'PRODUCTS.LIQUEUR_FRUIT_HERBAL.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        fruitOrHerbal | toSelectOption: 'PRODUCTS.LIQUEUR_FRUIT_HERBAL.'
      "
      (ngModelChange)="onFruitOrHerbalSelected($event)"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- fruitFlavor -->

  <mat-form-field *ngIf="getCtrl('fruitFlavor')">
    <app-easy-select
      formControlName="fruitFlavor"
      [label]="TITLE + 'LIQUEUR_FRUIT_FLAVOR' | translate"
      [translatePrefixForSelected]="'PRODUCTS.LIQUEUR_FRUIT_FLAVOR.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        fruitFlavors | toSelectOption: 'PRODUCTS.LIQUEUR_FRUIT_FLAVOR.':true
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- herbalFlavor -->

  <mat-form-field *ngIf="getCtrl('herbalFlavor')">
    <app-easy-select
      formControlName="herbalFlavor"
      [label]="TITLE + 'LIQUEUR_HERBAL_FLAVOR' | translate"
      [translatePrefixForSelected]="'PRODUCTS.LIQUEUR_HERBAL_FLAVOR.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        herbalFlavors | toSelectOption: 'PRODUCTS.LIQUEUR_HERBAL_FLAVOR.':true
      "
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
